module.exports = ".grid {\n  border-top-width: 1.25px;\n  border-right-width: 1.25px;\n  border-left-width: 1.25px;\n  border-bottom-width: 0px;\n  border-style: solid;\n  border-color: rgba(0, 0, 0, 0.12); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/custom-grid/custom-grid.component.scss
// module id = ./src/app/utils/custom-grid/custom-grid.component.scss
// module chunks = main